import React, { FC } from "react";

import {
  DetailsList,
  DetailsListItem,
} from "@UI/Components/DetailsList/DetailsList";
import { FooterLink } from "./FooterLink";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "./messages";

export const FooterCenterLinks: FC = () => {
  return (
    <DetailsList title={<FormattedMessage {...messages.needHelp} />}>
      <DetailsListItem>
        <FooterLink color="gray.700" route="HOW_IT_WORKS" reloadDocument>
          <FormattedMessage {...messages.howDoesItWork} />
        </FooterLink>
      </DetailsListItem>
      <DetailsListItem>
        <FooterLink color="gray.700" route="PRICING" reloadDocument>
          <FormattedMessage {...messages.subscriptionPlans} />
        </FooterLink>
      </DetailsListItem>
      <DetailsListItem>
        <FooterLink color="gray.700" route="SHARING_ECONOMY_LAW" reloadDocument>
          <FormattedMessage {...messages.isItLegal} />
        </FooterLink>
      </DetailsListItem>
      <DetailsListItem>
        <FooterLink color="gray.700" route="CONTACT_US" reloadDocument>
          <FormattedMessage {...messages.contactUs} />
        </FooterLink>
      </DetailsListItem>
      <DetailsListItem>
        <FooterLink color="gray.700" route="HELP_CENTER" reloadDocument>
          <FormattedMessage {...messages.helpFAQ} />
        </FooterLink>
      </DetailsListItem>
    </DetailsList>
  );
};
